export const NEW_FEATURE_FLAG_DESIGNER = 'designer';
export const NEW_FEATURE_FLAG_PRODUCTS_CREATE = 'products.create';
export const NEW_FEATURE_FLAG_PRODUCTS_EDIT = 'products.edit';
export const NEW_FEATURE_FLAG_SETTINGS = 'settings';
export const NEW_FEATURE_FLAG_STORE_CREDIT = 'storeCredit';
export const NEW_FEATURE_FLAG_DISCOUNTS = 'discounts';
